import React, { useState, useEffect } from "react";
import clinicbookingService from "../../../../../services/clinicbooking.service";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import AddIcon from "@mui/icons-material/Add";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/DeleteOutlined";
import SaveIcon from "@mui/icons-material/Save";
import CancelIcon from "@mui/icons-material/Close";
import {
  GridRowModes,
  DataGrid,
  GridToolbarContainer,
  GridActionsCellItem,
  GridRowEditStopReasons,
} from "@mui/x-data-grid";

function EditToolbar(props) {
  const { setCustomHours, setRowModesModel } = props;
  const handleClick = () => {
   
    const id = 999;
    setCustomHours((oldRows) => [
      ...oldRows,
      {
        id,
        workDate: "",
        isOff: "0",
        startTime: "10:00:00",
        endTime: "17:00:00",
        lunchFrom: "13:00:00",
        lunchTo: "13:30:00",
        isNew: true,
      },
    ]);
    setRowModesModel((oldModel) => ({
      ...oldModel,
      [id]: { mode: GridRowModes.Edit, fieldToFocus: "workDate" },
    }));
  };
  return (
    <GridToolbarContainer>
      <Button color="primary" startIcon={<AddIcon />} onClick={handleClick}>
        Add Custom Hour
      </Button>
    </GridToolbarContainer>
  );
}

function CustomHours({ doctorid, clinicid, userid }) {
  const [customHours, setCustomHours] = useState([]);
  const [rowModesModel, setRowModesModel] = useState({});
  const [paginationModel, setPaginationModel] = useState({
    page: 0,
    pageSize: 5,
  });
  const [rowCount, setRowCount] = useState(10);

  const handleRowEditStop = (params, event) => {
    if (params.reason === GridRowEditStopReasons.rowFocusOut) {
      event.defaultMuiPrevented = true;
    }
  };
  const handleEditClick = (id) => {
   
    setRowModesModel({ ...rowModesModel, [id]: { mode: GridRowModes.Edit } });
  };
  const handleSaveClick = (id) => () => {
  
    console.log(rowModesModel);
    setRowModesModel({ ...rowModesModel, [id]: { mode: GridRowModes.View } });
  };

  const handleDeleteClick = (id) => () => {
   
    clinicbookingService
      .deleteCustomHour(clinicid, doctorid, id)
      .then((res) => {
        setCustomHours(customHours.filter((row) => row.id !== id));
      })
      .catch((err) => {
        console.log("Error Deleting Row");
      });
  };

  const handleCancelClick = (id) => () => {
   
    setRowModesModel({
      ...rowModesModel,
      [id]: { mode: GridRowModes.View, ignoreModifications: true },
    });

    const editedRow = customHours.find((row) => row.id === id);
    if (editedRow.isNew) {
      setCustomHours(customHours.filter((row) => row.id !== id));
    }
  };
  
  const mySaveOnServerFunction = async (updatedRow) => {
    const updatedRowId = updatedRow.id;
    const rowDate = updatedRow.workDate;

    const dateObject = new Date(rowDate);
    const year = dateObject.getFullYear();
    const month = String(dateObject.getMonth() + 1).padStart(2, "0"); // Months are 0-indexed
    const day = String(dateObject.getDate()).padStart(2, "0");
    const formattedDate = `${year}-${month}-${day}`;
    let updatedRowCopy = updatedRow;

    if (updatedRow.isNew) {
      delete updatedRowCopy.id;
      delete updatedRowCopy.isNew;
    }
    updatedRowCopy.workDate = formattedDate;
    let newCustomHours = { ...updatedRowCopy };

    newCustomHours.userId = userid;
    newCustomHours.doctorId = doctorid;
    newCustomHours.clinicId = clinicid;
    let responseData = null;
    clinicbookingService
      .addCutomHour(clinicid, doctorid, newCustomHours)
      .then((res) => {
        responseData = res.data;
        setCustomHours(
          customHours.map((row) => {
            return row.id === updatedRowId ? responseData : row;
          })
        );
        //return res.data
      })
      .catch((err) => {
        console.log("Error: " + err);
      });
    return responseData;
  };
  
  const handleRowModesModelChange = (newRowModesModel) => {
  
    setRowModesModel(newRowModesModel);
  };
  const handleProcessRowUpdateError = () => {
    //console.log("Error handle process Row update");
  };
  const columns = [
    { field: "id", headerName: "ID" },
    {
      field: "workDate",
      headerName: "Work Date",
      type: "date",
      editable: true,
      valueGetter: ({ value }) => {
        //const newDate = new Date(value)
        const [year, month, day] = value.split("-").map(Number);
        const newDate = new Date(Date.UTC(year, month - 1, day + 1));

       // console.log("Value = " + value + " Date :" + newDate.toDateString());
        return newDate;
      },
    },
    { field: "isOff", headerName: "isOff", editable: true,
      renderCell :({value}) =>{
        if(value === 0){
          return <span className="badge text-bg-warning">Off</span>
        }else{
          return <span className="badge text-bg-success">Working</span>
        }
      }
    },
    { field: "startTime", headerName: "Start Time", editable: true },
    { field: "endTime", headerName: "End Time", editable: true },
    { field: "lunchFrom", headerName: "Lunch From", editable: true },
    { field: "lunchTo", headerName: "Lunch To", editable: true },
    {
      field: "actions",
      type: "actions",
      headerName: "Actions",
      cellClassName: "actions",
      getActions: ({ id }) => {
        const isInEditMode = rowModesModel[id]?.mode === GridRowModes.Edit;
        if (isInEditMode) {
          return [
            <GridActionsCellItem
              icon={<SaveIcon />}
              label="Save"
              sx={{
                color: "primary.main",
              }}
              onClick={handleSaveClick(id)}
            />,
            <GridActionsCellItem
              icon={<CancelIcon />}
              label="Cancel"
              className="textPrimary"
              onClick={handleCancelClick(id)}
              color="inherit"
            />,
          ];
        }
        return [
          <GridActionsCellItem
            icon={<EditIcon />}
            label="Edit"
            className="textPrimary"
            onClick={() => handleEditClick(id)}
            color="inherit"
          />,
          <GridActionsCellItem
            icon={<DeleteIcon />}
            label="Delete"
            onClick={handleDeleteClick(id)}
            color="inherit"
          />,
        ];
      },
    },
  ];

  useEffect(() => {
    getHours(
      clinicid,
      doctorid,
      paginationModel.page,
      paginationModel.pageSize
    );
   
  }, [paginationModel.page,paginationModel.pageSize]);

  const getHours = (cid, docid, pageNo, pageSize) => {
    clinicbookingService
      .getCustomHours(cid, docid, pageNo, pageSize)
      .then((res) => {
        setCustomHours(res.data.content);
       
        setRowCount(res.data.totalElements);
      })
      .catch((err) => {
        console.log(err);
      });
  };
  const addUpdateHours = (newHours) => {
    let newCustomHours = { ...newHours };
    newCustomHours.userId = userid;
    newCustomHours.doctorId = doctorid;
    newCustomHours.clinicId = clinicid;
  
    let responseData = null;
    clinicbookingService
      .addCutomHour(clinicid, doctorid, newCustomHours)
      .then((res) => {
       
        responseData = res.data;
        //return res.data
      })
      .catch((err) => {
        console.log("Error: " + err);
      });
    return responseData;
  };
  return (
    <>
      <hr />
      <div className="h3">Custom Hours</div>
      <hr />
      <div>
        <DataGrid
          rows={customHours}
          rowCount={rowCount}
          columns={columns}
          editMode="row"
          slots={{
            toolbar: EditToolbar,
          }}
          slotProps={{
            toolbar: { setCustomHours, setRowModesModel },
          }}
          rowModesModel={rowModesModel}
          onRowModesModelChange={handleRowModesModelChange}
          onRowEditStop={handleRowEditStop}
          processRowUpdate={(updatedRow, originalRow) => {
            mySaveOnServerFunction(updatedRow);
          }}
          onProcessRowUpdateError={handleProcessRowUpdateError}
          pagination
          paginationModel={paginationModel}
          pageSizeOptions={[5, 10, 15]}
          paginationMode="server"
          onPaginationModelChange={setPaginationModel}
        />
      </div>
    </>
  );
}

export default CustomHours;
